import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Accordion, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import './index.css';
import burgerIcon from '../../../assets/images/burger-icon.svg';
import closeIcon from '../../../assets/images/close-icon.svg';
import logo from '../../../assets/images/logo.png';
import venmologo from '../../../assets/images/venmologo.png';
import paypallogo from '../../../assets/images/paypallogo.png';
import squarelogo from '../../../assets/images/squarelogo.png';
import zelle from '../../../assets/images/zelle.png';
import venmo from '../../../assets/images/venmo.svg';
import paypal from '../../../assets/images/paypal.svg';
import cashapp from '../../../assets/images/cashapp.svg';
import zellelogo from '../../../assets/images/zellelogo.svg';
import editpen from '../../../assets/images/editpen.svg';

import Template from '../Template';
import { toast } from 'react-toastify';
import axios from 'axios';
import { DEV_API } from '../../../const';
import { USER_UPDATE } from '../../../store/actionTypes';

const PaymentEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);

    // Set the default active key to "0"
    const [activeKey, setActiveKey] = useState('0');

    const [payment, setPayment] = useState({
        venmo: '',
        paypal: '',
        cashApp: '',
        zelle: ''
    });

    useEffect(() => {
        setPayment(user.payment)
    }, [])

    const handleAccordionChange = (eventKey) => {
        // Toggle the accordion open/close based on the eventKey
        setActiveKey(eventKey === activeKey ? null : eventKey);
    };

    const handlePlayGame = async () => {
        const { venmo, paypal, cashApp, zelle } = payment;
        let updateData = {
            search: { _id: user._id },
            modify: {
                payment
            }
        }

        const response = await axios.put(`${DEV_API}/api/users`, updateData);

        if (response.data.success) {
            toast('Payments update successfully.')
            dispatch({ type: USER_UPDATE, payload: { user: response.data.result } });
            // if (venmo || paypal || cashApp || zelle) {
            //     navigate('/play');
            // } else {
            //     toast('A payout source is required to play for real money.')
            // }
        } else {
            toast(response.data.message);
        }

    }

    const handleChange = (evt, property) => {
        let updateData = { ...payment };
        updateData[property] = evt.target.value;
        setPayment(updateData);
    }

    return (
        <>
            <Template>
                <div className='screen-5-section'>
                    <div className='screen-5-content'>
                        <div className='screen-top-part'>
                            <div className='logo-part'>
                                <Link to="/">
                                    <img src={logo} alt="logo" className='img-fluid' />
                                </Link>
                            </div>
                            <span className='screen-title'>Add a Payout Source</span>
                            <p className='px-5 py-3 mt-3 text-white' style={{backgroundColor:'#1c1a1a94'}}>Payout sources are used to process entry fees and distribute winnings.</p>
                        </div>
                        <div className='payment-method-block'>
                            <div className='payment-method-list'>
                                <ul>
                                    <li><Link><img src={venmologo} alt="paymentlogo" className='img-fluid' /></Link></li>
                                    <li><Link><img src={paypallogo} alt="paymentlogo" className='img-fluid' /></Link></li>
                                    <li><Link><img src={squarelogo} alt="paymentlogo" className='img-fluid' /></Link></li>
                                    <li><Link><img src={zelle} alt="paymentlogo" className='img-fluid' /></Link></li>
                                </ul>
                            </div>
                            <div className='payment-method-process'>
                                <Accordion activeKey={activeKey} onSelect={handleAccordionChange}>
                                    <Accordion.Item eventKey="0" className={`accordion-item-custom ${activeKey === '0' ? 'expanded' : ''}`}>
                                        <Accordion.Header> <img src={venmo} alt="venmo" className='img-fluid' /> <span>Preferred</span> </Accordion.Header>
                                        <Accordion.Body>
                                            <Form>
                                                <Form.Group controlId="formGroupText" className='form-group'>
                                                    <Form.Control type="text" placeholder="Add your Venmo Username" value={payment.venmo} onChange={(evt) => { handleChange(evt, 'venmo') }} />
                                                    <img src={editpen} alt="edit" className='img-fluid' />
                                                </Form.Group>
                                            </Form>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1" className={`accordion-item-custom ${activeKey === '1' ? 'expanded' : ''}`}>
                                        <Accordion.Header><img src={paypal} alt="paypal" className='img-fluid' /></Accordion.Header>
                                        <Accordion.Body>
                                            <Form>
                                                <Form.Group controlId="formGroupText" className='form-group'>
                                                    <Form.Control type="text" placeholder="Add your Paypal Username" value={payment.paypal} onChange={(evt) => { handleChange(evt, 'paypal') }} />
                                                    <img src={editpen} alt="edit" className='img-fluid' />
                                                </Form.Group>
                                            </Form>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <Button className='submit-btn' onClick={() => handlePlayGame()}>Submit</Button>
                                <span className='payout-process-time'>Payouts are processed on Mondays</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>
        </>
    )
}

export default PaymentEdit
